const NAV_ITEMS = [
  { text: "Inicio", path: "/" },
  { text: "Alojamiento", path: "/alojamiento" },
  { text: "Experiencias", path: "/experiencias" },
  { text: "Como llegar", path: "/como-llegar" },
  { text: "Athos Pampa", path: "/athospampa" },
  { text: "Nuestros huéspedes", path: "/nuestros-huspedes" },
  { text: "Galería", path: "/galeria" },
  { text: "Contacto", path: "/contacto" },
];

export default NAV_ITEMS;
